import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from "@emotion/css";
import { Text } from "../text";
import { Icon } from "../icon";
import { ThemeConsumer } from "../theme";
import { Box } from "../box";
import styled from "@emotion/styled";
/**
 * A component that displays a checklist of items with completion status.
 *
 * @param {Props} props The props for the component.
 * @returns {JSX.Element} The rendered completion checklist component.
 */
export const CompletionChecklist = ({ completionChecklist, renderText, }) => (_jsx("div", { children: completionChecklist.map(checklist => (_jsxs(Box, { flexDirection: "row", alignItems: "center", className: "completionchecklist-0-56", children: [_jsx(ThemeConsumer, { children: theme => (_jsx("i", { className: sIcon, style: {
                        border: `1px solid ${theme.color.primary}`,
                        backgroundColor: `${checklist.complete ? theme.color.primary : "transparent"}`,
                    }, children: checklist.complete && _jsx(CheckIcon, { name: "check", color: "white" }) })) }), _jsx(Text, { fontSize: "1.25em", lineHeight: "1.75em", className: "completionchecklist-0-57", children: renderText(checklist.text) })] }, checklist.id))) }));
const sIcon = css `
  min-width: 1.5em;
  width: 1.5em;
  min-height: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 1.125em;
  padding-top: 0.25em;
  display: flex;
  justify-content: center;
`;
const CheckIcon = styled(Icon) `
  font-size: 0.875em;
`;
